import { render, staticRenderFns } from "./TransactionDetailSection.vue?vue&type=template&id=1e1335c3&"
import script from "./TransactionDetailSection.vue?vue&type=script&lang=ts&"
export * from "./TransactionDetailSection.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionDetailSection.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports